var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { amplitude } from "@sennder/senn-node-analytics-frontend";
const toKebabCase = (value) => value.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
const LOG_PREFIX = "[analytics-provider]";
class AnalyticsProvider {
  constructor({
    context,
    messageSource,
    logger,
    dedupePageEvents = false,
    formatEventName = (event) => event,
    formatPageEventName
  }) {
    __publicField(this, "_context");
    __publicField(this, "_messageSource");
    __publicField(this, "_dedupePageEvents");
    __publicField(this, "_lastPageEvent");
    __publicField(this, "_formatEventName");
    __publicField(this, "_formatPageEventName");
    __publicField(this, "_logger");
    this._context = context;
    this._messageSource = messageSource;
    this._logger = logger;
    this._dedupePageEvents = dedupePageEvents;
    this._formatEventName = formatEventName;
    this._formatPageEventName = formatPageEventName;
    this.trackEvent = this.trackEvent.bind(this);
    this.trackPage = this.trackPage.bind(this);
    this.setContext = this.setContext.bind(this);
  }
  executeSafelyWithLogging(callback, callbackName) {
    try {
      callback();
    } catch (error) {
      this._logger.error(
        `${LOG_PREFIX} (${this._messageSource}) Error while executing ${callbackName}: ${error}`,
        { error }
      );
    }
  }
  defaultFormatPageEventName(name) {
    if (!name) {
      throw Error("Empty page name");
    }
    return `${this._messageSource}/view/${toKebabCase(name)}-page`;
  }
  trackEvent(name, properties = {}) {
    if (!name) {
      this._logger.warn(
        `${LOG_PREFIX} Error executing trackEvent, empty event name`,
        {
          name,
          properties
        }
      );
      return;
    }
    this.executeSafelyWithLogging(() => {
      const eventName = this._formatEventName(name);
      if (this._dedupePageEvents && eventName.endsWith("-page")) {
        if (eventName !== this._lastPageEvent) {
          this._lastPageEvent = eventName;
        } else {
          return;
        }
      }
      amplitude.trackEvent({
        name: eventName,
        properties: {
          ...properties,
          submodule: properties.submodule || this._context.submodule,
          module: properties.module || this._context.module,
          source: this._messageSource,
          url: window.location.host
        }
      });
    }, "trackEvent");
  }
  trackPage(page, properties = {}) {
    this.executeSafelyWithLogging(() => {
      const pageEventName = this._formatPageEventName ? this._formatPageEventName(page) : this.defaultFormatPageEventName(page);
      if (this._dedupePageEvents) {
        if (pageEventName !== this._lastPageEvent) {
          this._lastPageEvent = pageEventName;
        } else {
          return;
        }
      }
      amplitude.trackEvent({
        name: pageEventName,
        properties: {
          ...properties,
          submodule: properties.submodule || this._context.submodule,
          module: properties.module || this._context.module,
          source: this._messageSource,
          url: window.location.host
        }
      });
    }, "trackPage");
  }
  forceTrackPageEvent() {
    this._lastPageEvent = void 0;
  }
  /**
   * Defines context for all events
   * @deprecated This method is deprecated. Please provide the context in the IModuleConfig interface or override the context in the trackEvent method
   * @param context AnalyticsMessageContext
   */
  setContext(context) {
    console.warn(
      "setContext is deprecated. Please provide the context in the IModuleConfig interface or override the context in the trackEvent method",
      context
    );
  }
}
export {
  AnalyticsProvider
};
